<template >
  <!-- <form> -->
    <div class="form-row col-md-11">
      <div class="form-group col-md-9">
        <label class="col-md-12">{{ $t("MOTIVO_CONSULTA.NOME") }}</label>
        <textarea
          rows="5"
          cols="40"
          required
          type="text"
          class="form-control"
          v-model="form.motivo"
          placeholder="Escribe el motivo..."
          data-kt-autosize="true"
        ></textarea>
      </div>
      <div class="form col-md-3 pt-5">
        <div class="form-group pt-5">
          <div
            class="
              form-check form-check-custom form-check-success form-check-solid
            "
          >
            <input
              class="form-check-input"
              value="1"
              v-model="form.merece_fe"
              type="radio"
              name="plan"
            />
            <label class="form-check-label"> Merece fe</label>
          </div>

          <div
            class="
              form-check form-check-custom form-check-danger form-check-solid
            "
          >
            <input
              class="form-check-input"
              value="0"
              v-model="form.merece_fe"
              type="radio"
              name="plan"
            />
            <label class="form-check-label" for="">No merece fe</label>
          </div>
        </div>
      </div>

      <div class="form-group col-md-12">
        <label class="col-md-12">{{ $t("DESCRIP_DATOS.NOME") }}</label>
        <input
          required
          type="text"
          class="form-control"
          v-model="form.dados_referidos"
          placeholder="Escribe..."
        />
      </div>

      <div class="form-group col-md-12">
        <label class="col-md-12">{{ $t("HDA.NOME") }}</label>
        <textarea
          required
          rows="5"
          cols="40"
          type="text"
          class="form-control"
          v-model="form.antecedentes_aea"
          placeholder="Escribe..."
          autosize="true"
        ></textarea>
      </div>
      <div class="form-group col-md-12">
        <label class="col-md-12">{{ $t("HRDA.NOME") }}</label>
        <textarea
          rows="5"
          cols="40"
          required
          type="text"
          class="form-control"
          v-model="form.antecedentes_area"
          placeholder="Escribe..."
        ></textarea>
      </div>
      <div class="form-group col-md-12">
        <label class="col-md-12">
          Antecedente Patologico Personal (A.P.P):</label
        >
        <textarea
          required
          type="text"
          class="form-control"
          v-model="form.antecedentes_app"
          placeholder="Escribe..."
        ></textarea>
      </div>
      <div class="form-group col-md-12">
        <label class="col-md-12">
          Antecedente Patologico Familiar (A.P.F):</label
        >
        <textarea
          rows="5"
          cols="40"
          required
          type="text"
          class="form-control"
          v-model="form.antecedentes_apf"
          placeholder="Escribe..."
        ></textarea>
      </div>
      <div class="form-group col-md-12">
        <label class="col-md-12"> Alergia a Medicamentos (R.A.M):*</label>
        <input
          required
          type="text"
          class="form-control"
          v-model="form.alergias"
          placeholder="Escribe..."
        />
      </div>
      <div class="form-group col-md-12">
        <label class="col-md-12"> {{ $t("INTERVENCION.NOME") }}*</label>
        <textarea
          rows="5"
          cols="40"
          required
          type="text"
          class="form-control"
          v-model="form.antecedentes_cirurgicos"
          placeholder="Escribe..."
        ></textarea>
      </div>
      <div class="form-group col-md-12">
        <label class="col-md-12">{{ $t("EXAMENES.NOME") }}*</label>
        <textarea
          rows="10"
          cols="70"
          required
          type="text"
          class="form-control"
          v-model="form.examen_fisico"
          placeholder="Escribe..."
        ></textarea>
      </div>
      <div class="form-group col-md-12">
        <label class="col-md-12"
          >Diagnóstico principal:*
          <span
            v-b-tooltip.hover
            title="Selecionar diagnostico principal del paciente conforme CIE-10. Es importante vincular el paciente a un diagnostico porque despues podemos filtrar consultas por diagnosticos"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              fill="currentColor"
              class="bi bi-question-circle-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M16 8A8 8 
                0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"
              /></svg></span>
        </label>
        <div>
          <b-dropdown split :text="texto" ref="select_diagnostico" class="m-2">
            <div class="navi navi-hover min-w-md-350px">
              <b-dropdown-text tag="div" class="navi-item">
                <input
                  v-model="input_pesquisa"
                  type="text"
                  class="form-control"
                  v_model="pesquisa_diagnostico"
                  i
                />
              </b-dropdown-text>
              <b-dropdown-text
                tag="div"
                class="navi-separator my-3"
              ></b-dropdown-text>
              <b-dropdown-text tag="div" class="navi-item">
                <b-table
                  :per-page="perPage"
                  :current-page="currentPage"
                  borderless
                  small
                  hover
                  :items="lista_diagnosticos"
                  :fields="fields"
                >
                  <template #cell(selecionar)="{ item }">
                    <button @click="selecionarDiagnostico(item)" class="btn btn-light-primary">
                      ok
                    </button>
                  </template>
                </b-table>
                <div>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="lista_diagnosticos.length"
                    size="sm"
                  ></b-pagination>
                </div>
              </b-dropdown-text>
            </div>
          </b-dropdown>
        </div>
      </div>
      <div class="form-group col-md-12">
        <label class="col-md-12">Descripcion Diagnóstico:*</label>
        <textarea
          rows="5"
          cols="40"
          required
          type="text"
          class="form-control"
          v-model="form.diagnostico"
          placeholder="Escribe..."
        ></textarea>
      </div>
      <div class="form-group col-md-12">
        <label class="col-md-12">{{ $t("CONDUCTA.NOME") }}*</label>
        <textarea
          rows="5"
          cols="40"
          required
          type="text"
          class="form-control"
          v-model="form.conduta"
          placeholder="Escriba la conducta a ser tomada..."
        ></textarea>
      </div>
      <div class="col-md-11 mt-2">
        <button
          @click.prevent="confirm(lista_campos == '' ? 'cria' : 'edita')"
          class="btn btn-primary float-right"
          :disabled="verif"
        >
          {{ $t("GERENCIAR.NOME") }}
          <b-spinner
            v-show="verif"
            small
            variant="dark"
            type="grow"
            label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </div>
  <!-- </form> -->
</template>

<script>
import Swal from "sweetalert2";
import { fireAlert } from "@/core/mixins/alertMessageMixin";
import { drowpdow } from "../../content/dropdown/Dropdown1.vue";
export default {
  mixins: [fireAlert],
  components: { drowpdow },
  //  props:{

  //  },
  data() {
    return {
      verif: false,
      //info tabela pesquisa diagnostico
      texto: "Selecionar Diagnostico Principal conforme CIE-10",
      fields: ["codigo", "nome", "selecionar"],
      perPage: 5,
      currentPage: 3,
      input_pesquisa: "",
      //fim info diagnostico
      form: {
        antecedentes_aea: "",
        antecedentes_area: "",
        antecedentes_app: "",
        antecedentes_apf: "",
        antecedentes_cirurgicos: "",
        alergias: "",
        examen_fisico: "",
        motivo: "",
        merece_fe: true,
        diagnostico: "",
        conduta: "",
        atendimento_id: "",
        diagnostico_id: "",
      },

      radio: null,
    };
  },
  watch: {
    input_pesquisa() {
      if (this.input_pesquisa.length >= 3) {
        this.listar_diagnostico();
      }
    },
    lista_campos(){
      this.preenxerCampos();
    }
  },
  computed: {
    dados_diagnostico(){
      return this.$store.state.ocorrencia.dados_diagnostico;
    },
    lista_campos() {
      return this.$store.state.configEmpresa.lista_campos;
    },
    lista_diagnosticos() {
      return this.$store.state.configEmpresa.lista_diagnosticos;
    },
    mensagem_alert() {
      return this.$store.state.ocorrencia.mensagem_alert;
    },
  },
  created() {
    this.preenxerCampos();
  },

  methods: {
    async confirm(tipo) {
      await this.$confirm({
        title: "Estas seguro?",
        message: `Esta ação  ` + tipo + ` un atendimento no sistema?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            if (tipo == "cria") this.create();
            if (tipo == "edita") this.update();
          }
        },
      });
    },
    async create() {
      const { atendimento_id } = this.$route.params;
      this.form.atendimento_id = atendimento_id;
      console.log(this.form);
      this.verif = true;
      await this.$store
        .dispatch("ocorrencia/create_consulta", this.form)
        .finally(() => {
          // using "finally" so even if there are errors, it stops "loading"
          this.verif = false;
          this.alertError()

        });

    },
    alertError(){
      if(this.mensagem_alert.tipo == "error"){
        var texto = "Verificar los campos: "
        var erros = this.mensagem_alert.message.errors
        console.log("erros",erros)

        if(erros.hasOwnProperty('alergias')){
          texto = texto + 'ALERGIA, '
        }
        if(erros.hasOwnProperty('antecedentes_aea')){
          texto = texto + 'Antecedentes de la Enfermedad Actual, '
        }
        if(erros.hasOwnProperty('antecedentes_apf')){
          texto = texto + 'Antecedente Patologico Familiar (A.P.F):, '
        }
        if(erros.hasOwnProperty('antecedentes_app')){
          texto = texto + 'Antecedente Patologico Personal (A.P.P):, '
        }
        if(erros.hasOwnProperty('antecedentes_area')){
          texto = texto + 'Antecedentes Remotos de Enfermedad Actual (A.R.E.A), '
        }
        if(erros.hasOwnProperty('conduta')){
          texto = texto + 'Conducta, '
        }
        if(erros.hasOwnProperty('diagnostico')){
          texto = texto + 'Dianostico, '
        }
        if(erros.hasOwnProperty('dados_referidos')){
          texto = texto + 'datos referidos, '
        }
        if(erros.hasOwnProperty('examen_fisico')){
          texto = texto + 'Examen fisico, '
        }
        if(erros.hasOwnProperty('motivo')){
          texto = texto + 'Motivo de consulta, '
        }
        if(erros.hasOwnProperty('antecedentes_cirurgicos')){
          texto = texto + 'Antecedentes de Intervenciones quirúrgicas, '
        }
        var dados ={
          tipo:"Consulta",
          fechar:false,
        }
        this.$store.dispatch("ocorrencia/save_dados_modais",dados)

        Swal.fire({
          title: 'Problema con los datos!',
          text: texto,
          footer: 'Todos los campos son obrigatorios, puedes poner un "-" o "niega" si no hay antecedentes',
          confirmButtonText: "Terminar de llenar",
          confirmButtonColor:'#ff6060',
        // customClass: {
        //   icon: "center",
        // },
      });
        
      }else{
        this.fireAlert(this.mensagem_alert.message)
        var dados ={
          tipo:"Consulta",
          fechar:true,
        }
        this.$store.dispatch("ocorrencia/save_dados_modais",dados)
      }
    },
    async update() {
      const { atendimento_id } = this.$route.params;
      this.form.atendimento_id = atendimento_id;
      this.verif = true;
      await this.$store
        .dispatch("ocorrencia/update_consulta", this.form)
        .finally(() => {
          // using "finally" so even if there are errors, it stops "loading"
          this.verif = false;
          this.fireAlert(this.mensagem_alert.message);
        });
    },
    async listar_diagnostico() {
      await this.$store.dispatch(
        "configEmpresa/pesquisar_diagnosticos",
        this.input_pesquisa
      );
      console.log(this.lista_diagnosticos);
    },
    selecionarDiagnostico(item) {
      this.texto = item.codigo+' - '+ item.nome
      this.form.diagnostico_id = item.id
      this.$refs.select_diagnostico.hide(true)
    },
    async  preenxerCampos() {
      if (this.lista_campos != "") {
        var val = this.lista_campos;
        this.form = val.ocorrencia;
        this.form.tipo_ocorrencia_id = val.tipo_ocorrencia_id;
        this.form.grau_urgencia_id = val.grau_urgencia_id;
        this.form.ocorrencia_id = val.id;
        if(this.lista_campos.ocorrencia.diagnostico_id != null){
          await this.$store.dispatch('ocorrencia/getDiagnosticoId',this.lista_campos.ocorrencia.diagnostico_id)
          this.texto = this.dados_diagnostico.codigo + ' - ' + this.dados_diagnostico.nome
        }else{
          this.texto = "Selecionar Diagnostico Principal conforme CIE-10"
        }
      }
    },
  },

 
  //  watch:{
  //    lista_campos: function (val) {

  //     this.form = val.ocorrencia
  //     this.form.tipo_ocorrencia_id = val.tipo_ocorrencia_id
  //        this.form.grau_urgencia_id = val.grau_urgencia_id
  //   },
  // }
};
</script>
